module.exports = __webpack_public_path__ + "img/pic2.18c8b893.jpg";